// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1I_tF","content":"LayoutSettings_content__2mtn6"};